import { formLabelClasses } from '@mui/material';
export const MuiFormLabel = {
    styleOverrides: {
        root: {
            [`&.${formLabelClasses.focused}`]: {
                color: 'inherit'
            }
        }
    }
};

//# sourceMappingURL=form-label.js.map